import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Col, Row } from "reactstrap";
import styles from "./styles.module.scss";

export const ImageWithTextBanner = ({
  className,
  content,
  buttons,
  image,
  inverted,
  sectionId,
}) => {
  return (
    <section className={`${styles.root} ${className}`} id={sectionId}>
      <Row className={`m-0 ${inverted ? "flex-row-reverse" : ""}`}>
        <Col md={8} className="left-column d-flex align-items-center py-5">
          {content ? (
            <div className="mb-4">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          ) : null}
          {buttons?.length > 0 && (
            <div className="mt-3 d-flex gap-2 flex-wrap">
              {buttons.map(({ id, url, label, className }) => (
                <a key={id} href={url} className={className}>
                  {label}
                </a>
              ))}
            </div>
          )}
        </Col>
        <Col md={4} className="right-column p-0">
          <figure className="ratio ratio-4x3 m-0 h-100">
            <SourceFlowImage
              src={
                image?.url
                  ? image?.url
                  : "/site-assets/placeholders/img-placeholder.jpg"
              }
              size={"600x600"}
              alt={image?.alt}
              className="card-img bg-white h-100"
            />
          </figure>
        </Col>
      </Row>
    </section>
  );
};

export default ImageWithTextBanner;
